import {
  applyMiddleware,
  compose,
  legacy_createStore as createStore,
} from "redux";
import logger from "redux-logger";
import { thunk } from "redux-thunk";
import rootReducer from "../reducers";

window.devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
const configureStore = (preloadedState) => {
  const middleware = [thunk];
  if (!window.devToolsExtension) {
    middleware.push(logger);
  }
  const store = createStore(
    rootReducer,
    preloadedState,
    compose(
      applyMiddleware(...middleware),
      window.devToolsExtension ? window.devToolsExtension() : (f) => f, // add support for Redux dev tools
    ),
  );

  if (import.meta.hot) {
    // Enable Vite hot module replacement for reducers
    import.meta.hot.accept("../reducers", (newModule) => {
      if (newModule) {
        store.replaceReducer(newModule.default);
      }
    });
  }

  return store;
};

export default configureStore;
